import { render } from "./LoginHeader.vue?vue&type=template&id=5a9da97e&scoped=true"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"

import "./LoginHeader.vue?vue&type=style&index=0&id=5a9da97e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9da97e"]])

export default __exports__